/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import Loader from '.';

export const BlockingLoader = () => {

  return (
    <div className='blocking-loader'>
      <Loader />
    </div>
  )
}
